import { DummyStore } from 'stores';

import { Transaction } from '../types/transaction.type';

export namespace TransactionStore {
  export const transaction = new DummyStore<Transaction>();
}
